import { Button } from '@design-system';
import { ShieldOff, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface EdjPilotQaABlockedProps {
  clientId?: string;
}

export function EdjPilotQaABlocked({ clientId }: EdjPilotQaABlockedProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (clientId) {
      navigate(`/clients/${clientId}/onboarding/funding-sources`);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="bg-background flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <div className="bg-muted mx-auto mb-6 flex size-16 items-center justify-center rounded-full">
          <ShieldOff className="text-foreground size-8" />
        </div>
        <h1 className="text-balance text-xl font-semibold text-gray-950">
          Quote & Apply is not available for Edward Jones pilot advisors
        </h1>
        <p className="text-foreground mt-3 text-balance">
          To evaluate insurance options during the pilot, follow your standard processes outside of Waterlily.
        </p>
        <div className="mt-8">
          <Button
            variant="outline"
            onClick={handleBack}
          >
            <ArrowLeft className="size-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
